import type { ReactNode } from 'react'

import { Page, PageHeader } from '@aeris/ui'

import { ClaudeConnections } from '../components/claude-connections.tsx'
import { MyAssistantWhatsapp } from '../components/my-assistant-whatsapp.tsx'

/**
 * Meu assistente (F253–F255): o que é DA PESSOA no assistente.
 *
 * Conectar o Claude à loja com o próprio usuário (F253) e, na F254, ligar o
 * próprio WhatsApp ao número do assistente. O assistente responde só o que o
 * acesso dela já vê nas telas.
 */
export const MeuAssistentePage = (): ReactNode => (
  <Page>
    <PageHeader
      title="Meu assistente"
      description="Pergunte os números da loja pelo WhatsApp e pelo Claude, com o seu acesso. Só leitura."
    />
    <MyAssistantWhatsapp />
    <ClaudeConnections everyone={false} />
  </Page>
)
